import BlockUi from './BlockUi';
import { connect } from 'react-redux';
var mapStateToProps = function (state) {
    return {
        isBlocked: state.blockui.isBlocked
    };
};
export default connect(mapStateToProps)(BlockUi);



//////////////////
// WEBPACK FOOTER
// ./src/containers/BlockUi/index.tsx
// module id = 1520
// module chunks = 0